module.exports = __webpack_public_path__ + "static/media/blindSelectHead_blind_1.6ad5f55c.png";